import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({ providedIn: 'root' })
export class DeviceService {
  private basePath = '/reports/devices';

  constructor(private backend: BackendService) {}

  getDevices() {
    return this.backend.post(this.basePath , {});
  }

  allowDevice(id: string) {
    return this.backend.post(`${this.basePath}/${id}/allow`, {});
  }

  denyDevice(id: string) {
    return this.backend.post(`${this.basePath}/${id}/deny`, {});
  }
}
